module.exports = __webpack_public_path__ + "static/img/banner09-02.e26da40d.png";